import client from "../../client/client";

class ProjectDocumentsService {
	getDirectory({ projectId, directoryId, notificationStatus }, cancelToken) {
		const params = {};
		if (notificationStatus) {
			params.notificationStatus = notificationStatus;
		}
		return client.get(`/smartview/projects/${projectId}/document-tabs/directories/${directoryId}`, {
			params,
			config: { cancelToken },
		});
	}

	getRoot({ projectId, notificationStatus }, { limit = 25, page = 0, search = "" }, cancelToken) {
		const params = { limit, page, search };
		if (notificationStatus) {
			params.notificationStatus = notificationStatus;
		}
		return client.get(`/smartview/projects/${projectId}/document-tabs/directories/root`, {
			params,
			config: { cancelToken },
		});
	}

	getAllPrecedences({ projectId }, cancelToken) {
		return client.get(`/smartview/projects/${projectId}/document-tabs/me/precedence`, {
			config: { cancelToken },
		});
	}

	getPrecedence({ precedenceId }, cancelToken) {
		return client.get(`/smartview/document-tabs/me/precedence/${precedenceId}`, {
			config: { cancelToken },
		});
	}

	getAllRoles({ projectId }, cancelToken) {
		return client.get(`/smartview/projects/${projectId}/document-tabs/me/roles`, {
			config: { cancelToken },
		});
	}

	getRole({ projectId, role }, cancelToken) {
		return client.get(`/smartview/projects/${projectId}/document-tabs/me/roles/${role}`, {
			config: { cancelToken },
		});
	}

	getDocumentNames({ projectId, ids }, cancelToken) {
		if (!ids || ids.length === 0) {
			return Promise.resolve([]);
		}
		return client.get(`/smartview/projects/${projectId}/document-tabs/documents/names`, {
			params: { ids: ids.join(",") },
			config: { cancelToken },
		});
	}
}

export default new ProjectDocumentsService();
